import { useState } from "react";
import { LuLoaderCircle, LuSave } from "react-icons/lu";
import { components } from "../../../design/tokens";
import { useSnackbar } from "../../../providers/SnackbarProvider";
import { useProjectIconActions } from "../../../view_stores/useProjectIconStore";

export default function ProjectIconUploadedImageActions() {
  const { saveUploadedImage, setUploadedImage } = useProjectIconActions();
  const { showSnackbar } = useSnackbar();
  const [isSaving, setIsSaving] = useState(false);

  const handleRemoveImage = () => {
    setUploadedImage(null);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await saveUploadedImage();
      showSnackbar("Image saved successfully");
    } catch (e) {
      showSnackbar("Failed to save image. Try again later.", {
        type: "error",
      });
    }
    setIsSaving(false);
  };

  return (
    <>
      <button
        id="project-icon-uploaded-image-actions-remove"
        onClick={handleRemoveImage}
        className="text-dark-placeholder
                hover:opacity-90
                transition-opacity duration-300 px-4
                disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={isSaving}
      >
        Cancel
      </button>
      <button
        id="project-icon-uploaded-image-actions-save"
        className={`${components.button.primary} gap-3`}
        onClick={handleSave}
        disabled={isSaving}
      >
        {isSaving ? (
          <LuLoaderCircle className="animate-spin" size={20} />
        ) : (
          <LuSave size={20} />
        )}
        {isSaving ? "Saving..." : "Save"}
      </button>
    </>
  );
}
